module.exports = __webpack_public_path__ + "static/media/StarCoreValuesModal.f6108295.svg";